module.exports = __webpack_public_path__ + "assets/img/2610.94557785.svg";